export default __webpack_public_path__ + "static/modal-do-light-66e6c4627c27f6430b40350d7b02575be559f56b324df42d307aed74d32309d8.png";